import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";

// Confirm before a seated player walks away from a table (blinds / wagers in the current hand are lost; SNG buy-in forfeited once started).
export const LeaveTableDialog = ({ open, sngStarted, isMtt = false, onCancel, onLeave }) => (
  <AlertDialog open={open} onOpenChange={(v) => !v && onCancel()}>
    <AlertDialogContent data-testid="leave-table-dialog" className="glass border-amber-400/40 bg-black/90 text-slate-100 max-w-md">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display text-amber-200 tracking-wide">Are you sure you want to leave the table?</AlertDialogTitle>
        <AlertDialogDescription className="text-slate-300">
          Any blinds or wagers will be forfeited.{sngStarted ? ` This ${isMtt ? "tournament" : "Sit N Go"} has started — your buy-in is forfeited and you can't rejoin it.` : ""}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="leave-table-cancel" onClick={onCancel} className="rounded-full border-white/15 bg-white/5 text-slate-200 hover:bg-white/10 hover:text-white">Cancel</AlertDialogCancel>
        <AlertDialogAction data-testid="leave-table-confirm" onClick={onLeave} className="rounded-full bg-red-600 hover:bg-red-500 text-white font-display tracking-wider">Leave</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
